

import React, { useState } from 'react';
import styles from '../../src/assets/scss/UserInvite.module.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Pagination from '../Components/Common/Pagination';
import { useGetInvitesQuery } from '../slices/admin/admin';
import InviteFrom from './InviteFrom';
import { getUserInfo } from '../utils/user.util';

const UserInvite = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const user = getUserInfo();
  const restrictedRoles = ['siteadmin', 'siteowner', 'sitesupport'];
  const isRestricted = restrictedRoles.includes(user?.type);

  const activeTab = isRestricted ? 'Invite To' : (searchParams.get('tab') || 'Invite From');

  const setActiveTab = (tab) => {
    if (isRestricted && tab === 'Invite From') return;
    setSearchParams({ tab });
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');

  const rowsPerPage = 10;
  const offset = (currentPage - 1) + 1;

  const statusParam =
    selectedStatus === 'Accepted'
      ? true
      : selectedStatus === 'Not Accepted'
        ? false
        : undefined;

  const {
    data: apiData = {},
    isLoading,
    isError,
    error,
  } = useGetInvitesQuery({
    offset,
    limit: rowsPerPage,
    search: searchValue,
    isAccepted: statusParam,
  });

  const invites = apiData.result || [];
  const totalCount = apiData.total || 0;
  const totalPages = Math.ceil(totalCount / rowsPerPage);

  const navigate = useNavigate();

  const handleClickInvite = () => {
    navigate('/dashboard/AddInvite');
  };

  const handleClearFilters = () => {
    setSearchValue('');
    setSelectedStatus('');
    setCurrentPage(1);
  };
  return (
    <div className={styles.dashboard}>
      <div className={styles.tabButtons}>
        <div className={styles.dflex}>
          {!isRestricted && (
            <button
              className={`${styles.tabButton} ${activeTab === 'Invite From' ? styles.activeTab : ''}`}
              onClick={() => setActiveTab('Invite From')}
            >
              Invite From
            </button>
          )}
          <button
            className={`${styles.tabButton} ${activeTab === 'Invite To' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('Invite To')}
          >
            Invite To
          </button>
        </div>
      </div>
      <div className={styles.main}>


        {activeTab === 'Invite To' && (
          <>
            <div className={styles.topBar}>
              <div className={styles.filterContainer}>
                <input
                  type="text"
                  placeholder="Search here..."
                  className={styles.searchInput}
                  value={searchValue}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <select
                  className={styles.statusSelect}
                  value={selectedStatus}
                  onChange={(e) => {
                    setSelectedStatus(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">All</option>
                  <option value="Accepted">Accepted</option>
                  <option value="Not Accepted">Not Accepted</option>
                </select>
                <button className={styles.clearBtn} onClick={handleClearFilters}>
                  Clear All
                </button>
              </div>
              <div>
                <button className={styles.sendInvite} onClick={handleClickInvite}>
                  + Send Invite
                </button>
              </div>
            </div>

            {isLoading ? (
              <p>Loading...</p>
            ) : isError ? (
              <p>{error?.data?.message || 'Failed to load data'}</p>
            ) : (
              <table className={styles.table}>
                <thead>
                  <tr>
                    {/* <th><input type="checkbox" /></th> */}
                    <th>Invite To</th>
                    <th>Phone Number</th>
                    <th>Email ID</th>
                    <th>User Type</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {invites.length === 0 ? (
                    <tr>
                      <td colSpan="5" className={styles.noData}>No record found</td>
                    </tr>
                  ) : (
                    invites.map((user) => (
                      <tr key={user._id}>
                        {/* <td><input type="checkbox" /></td> */}
                        <td>{user.name}</td>
                        <td className='notranslate'>{user.phone}</td>
                        <td>{user.email}</td>
                        <td>{user.type}</td>
                        <td className={user.isAccepted ? styles.active : styles.inactive}>
                          {user.isAccepted ? 'Accepted' : 'Not Accepted'}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            )}
            <div className={styles.margin}>

              {totalCount > 0 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              )}
            </div>
          </>
        )}

        {activeTab === 'Invite From' && !isRestricted && (
          <InviteFrom />
        )}
      </div>
    </div>
  );
};

export default UserInvite;


